import React from 'react'
import { Typography } from 'antd'
import { CloudDownloadOutlined } from '@ant-design/icons'
import styles from './CustomLink.module.scss'
const { Title, Text } = Typography

interface CustomLinkProps {
  label: string,
  link: string,
  icon?: React.ReactNode,
  target?: string,
  isDisabled?: boolean
  isSmallText?: boolean
  isStrong?: boolean
  showIcon?: boolean
}

const CustomLink: React.FC<CustomLinkProps> = (props) => {
  const {
    icon = <CloudDownloadOutlined />,
    target = '_blank',
    isDisabled = false,
    isSmallText = false,
    label,
    link,
    isStrong = false,
    showIcon = true
  } = props
  const classes = isDisabled ? styles['disabled'] : styles['link']

  const text = showIcon ? <>{icon} {label}</> : label

  return (
    <a
      className={classes}
      target={target}
      href={link}
    >
      {isSmallText ? <Text strong={isStrong}>{text}</Text>: <Title level={5} type='secondary'>{text}</Title>}
    </a>
  )
}

export default CustomLink
